<template>
  <v-container fluid fill-height>
    <v-layout column align-center justify-center class="text-xs-center">
      <v-flex shrink>
        <img src="../..//public/img/kingdom-4.png" style="height:25vh" />
      </v-flex>
      <v-layout align-start justify-center>
        <v-flex v-if="!done" xs12 md7>
          <v-layout column>
            <v-flex class="display-2 font-weight-black">
              How are we doing?
            </v-flex>
            <br />
            <v-flex class="">
              This software is in its inital alpha stage. Any feedback from you
              would help a great deal and would be greatly appreciated!
            </v-flex>

            <v-flex>
              <v-textarea
                label="What is good"
                rows="3"
                v-model="good"
              ></v-textarea>
            </v-flex>

            <v-flex>
              <v-textarea
                label="What is bad"
                rows="3"
                v-model="bad"
              ></v-textarea>
            </v-flex>

            <v-flex>
              <v-textarea
                label="Feature Request"
                rows="3"
                v-model="feature"
              ></v-textarea>
            </v-flex>

            <v-flex>
              Please contact me at <strong>hanzhaodeng@gmail.com</strong> you
              have any questions or suggestions.
            </v-flex>
            <br />
            <v-flex>
              <v-btn class="elevation-2" color="primary" @click="onSave">
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex shrink v-if="done" class="display-2 font-weight-black">
          Thank you so much!
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import { firestore } from "@/firebase";
import { autoId } from "@/lib/autoId";
export default {
  data() {
    return {
      good: "",
      bad: "",
      feature: "",
      done: false
    };
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    async onSave() {
      await firestore
        .doc(`users/${this.user.uid}/feedback/${autoId()}`)
        .set({ good: this.good, bad: this.bad, feature: this.feature });
      this.done = true;
    }
  }
};
</script>
